import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="relative w-full bg-black py-10 overflow-hidden" data-id="element-190">
      <div className="absolute inset-0 z-0" data-id="element-191">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-yellow-900/10 blur-[100px]" data-id="element-192" />
      </div>

      <div className="relative z-20 max-w-3xl mx-auto px-6" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-yellow-600/30 rounded-xl p-8 md:p-10 text-center shadow-[0_0_40px_rgba(251,191,36,0.05)] overflow-hidden" data-id="element-194">
          <div className="absolute inset-0 bg-yellow-600/5 blur-2xl" data-id="element-195" />

          <div className="relative z-10" data-id="element-196">
            <div className="w-16 h-16 mx-auto bg-gradient-to-br from-yellow-500 to-yellow-700 rounded-full flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(251,191,36,0.3)]" data-id="element-197">
              <span className="text-3xl" data-id="element-198">🛡️</span>
            </div>

            <h2 className="font-display text-3xl md:text-4xl uppercase mb-4 text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-199">
              Garantía de Satisfacción
            </h2>

            <p className="text-lg md:text-xl font-semibold text-yellow-500 mb-4" data-id="element-200">
              Prueba el sistema sin riesgo.
            </p>

            <p className="text-gray-300 text-sm md:text-base leading-relaxed max-w-xl mx-auto" data-id="element-201">
              Si consideras que el programa no es para ti durante los primeros{' '}
              <span className="text-white font-bold" data-id="element-202">7 días</span>, podrás
              solicitar la devolución de tu dinero. Sin preguntas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}